import './productionLots.view.scss'
import templateUrl from './productionLots.view.html'

/**
 * ProductionLot detail Report route
 *
 * @namespace routes.ReportProductionLotView
 * @type {TmrRoute}
 */
export const route = {
  name: 'report.productionLots.view',
  label: 'REPORT.PRODUCTIONLOTS.VIEW.TITLE',
  component: 'tmrReportProductionLotView',
  accessControl: ['Resource.view', 'Resource.ProductionLot.view'],
  abstract: false,
  paging: true,
  resolve: {
    /** Retrieves the production workflows of the place of the active user. */
    productionWorkflows: /*@ngInject*/ (ProductionWorkflow, loggedUser) =>
      ProductionWorkflow.query({ 'worker.id': loggedUser.place.id }).$promise,
  },
}

/**
 * Component for {@link routes.tmrReportProductionLotView ProductionLots Report route}
 *
 * @type {ngComponent}
 */
export const tmrReportProductionLotView = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrReportProductionLotViewController',
  bindings: {
    resource: '<',
    currentPage: '<',
    pageSize: '<',
    productionWorkflows: '<',
  },
}

/**
 * Controller of component {@link tmrReportProductionLotView}.
 *
 * @type {ngController}
 */
export class tmrReportProductionLotViewController {
  constructor($translate) {
    'ngInject'
    Object.assign(this, { $translate })
  }

  static ngType = 'controller'

  $onInit() {
    // Get ordered production workflow phases
    const userWorkflows = this.productionWorkflows
      ? this.productionWorkflows[0]
      : []
    this.orderedPhases = []
    if (userWorkflows.phases) {
      this.orderedPhases = userWorkflows.phases.sort((a, b) =>
        a.phaseOrder > b.phaseOrder ? 1 : b.phaseOrder > a.phaseOrder ? -1 : 0
      )
    }

    this.getLotLeadTime()
  }

  /** Get Lead time for single phase */
  getLeadTimePhase(start, completion, returnType) {
    // get total seconds between the times
    let delta = Math.abs(completion - start) / 1000

    if (returnType === 'seconds') return delta

    // get diff date time object
    const diff = this.getDiffDateTimeFromSeconds(delta)

    // check if want label as return
    if (returnType === 'label') return this.getDiffLabelFromObject(diff)

    return diff
  }

  /** Get lead time for entire lot if it's completed */
  getLotLeadTime() {
    // Init values
    this.showTotalLeadTime = false
    this.totalLeadTime = 0
    this.totalPhasesLeadTime = 0

    const phasesLength = this.orderedPhases.length
    // Check if all phases are completed
    if (
      phasesLength === this.resource.phases.length &&
      this.resource.phases[phasesLength - 1].completionDate
    ) {
      this.showTotalLeadTime = true

      // get total lead time between startDate of first phase and completionDate of last phase
      const startDateLot = this.resource.phases[0].startDate
      const completionDateLot =
        this.resource.phases[phasesLength - 1].completionDate
      const diff = this.getLeadTimePhase(
        startDateLot,
        completionDateLot,
        'label'
      )
      this.totalLeadTime = diff

      // get total lead time of single phase
      let phasesLeadTime = 0
      this.resource.phases.forEach(phase => {
        if (phase.completionDate && phase.startDate) {
          phasesLeadTime += this.getLeadTimePhase(
            phase.startDate,
            phase.completionDate,
            'seconds'
          )
        }
      })
      const totalDiff = this.getDiffDateTimeFromSeconds(phasesLeadTime)
      this.totalPhasesLeadTime = this.getDiffLabelFromObject(totalDiff)
    }
  }

  // from seconds, return object with days/hours/mins/seconds
  getDiffDateTimeFromSeconds(dateInSeconds) {
    let delta = dateInSeconds
    // calculate (and subtract) whole days
    let days = Math.floor(delta / 86400)
    delta -= days * 86400
    // calculate (and subtract) whole hours
    let hours = Math.floor(delta / 3600) % 24
    delta -= hours * 3600
    // calculate (and subtract) whole minutes
    let minutes = Math.floor(delta / 60) % 60
    delta -= minutes * 60
    // calculate seconds
    let seconds = Math.round(delta % 60)

    return { days, hours, minutes, seconds }
  }

  // get label from dateDiff object
  getDiffLabelFromObject(dateTimeObject) {
    const diff = dateTimeObject
    const showDay = diff.days
      ? `${diff.days} ${this.$translate.instant('RESOURCELIST.DAYS_SHORT')} - `
      : ''
    return `${showDay} ${diff.hours} h ${diff.minutes} min ${diff.seconds} s`
  }
}
